module.exports = __webpack_public_path__ + "cuttingLineTop.png?f768bd5779004c4d2addc56341f3dd8a";